// export const BASE_URL = "http://10.10.1.134:4000/staff-api";
export const BASE_URL = process.env.APP_BASE_URL;

export const USER_URL = `/user`;
export const WORKBOOK_URL = `/workbook`;
export const SHEET_URL = `/sheet`;
export const SHEETDATA_URL = `/sheetdata`;
export const COLDEFS_URL = `/sheet/colDefs`;
export const SET_INITIAL_ROWS = "/sheetdata/insert-initial-rows";
export const ELASTIC_URL='/elasticsearch'
export const JIRA_URL='/jira'
